export class HasFlagValueConverter {
    toView(value: number, flag: number) {
        return (value & flag) > 0;
    }
}
